import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Navigation } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT, SERVICES, SHORT_NAMES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#08090B]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <Logo size={44} />
              <span className="font-display text-2xl font-black uppercase tracking-tight text-white">
                Bowegans
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-gray-400">
              Precision aftermarket fitting and premium vehicle care on NH.83, Palani.
              Built for enthusiasts who refuse factory limitations.
            </p>
            <p className="font-display mt-8 text-4xl font-black uppercase leading-none text-stroke sm:text-5xl">
              Drive<br />Different.
            </p>
          </div>

          <div>
            <h4 className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#3B82F6]">Pages</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { to: "/", label: "Home", id: "footer-home-link" },
                { to: "/services", label: "Services", id: "footer-services-link" },
                { to: "/about", label: "About Us", id: "footer-about-link" },
                { to: "/reviews", label: "Reviews", id: "footer-reviews-link" },
                { to: "/store", label: "Online Store", id: "footer-store-link" },
                { to: "/contact", label: "Book & Contact", id: "footer-contact-link" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={l.id} className="text-gray-400 transition-colors hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#3B82F6]">Services</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/contact?service=${s.id}`}
                    data-testid={`footer-service-${s.id}`}
                    className="text-gray-400 transition-colors hover:text-white"
                  >
                    {SHORT_NAMES[s.id] || s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#3B82F6]">Reach Us</h4>
            <div className="mt-4 space-y-4 text-sm">
              <a
                href={CONTACT.phoneLink}
                data-testid="footer-phone-link"
                className="flex items-center gap-3 text-gray-300 transition-colors hover:text-white"
              >
                <Phone className="h-4 w-4 shrink-0 text-[#3B82F6]" />
                {CONTACT.phoneDisplay}
              </a>
              <a
                href={CONTACT.phone2Link}
                data-testid="footer-phone2-link"
                className="flex items-center gap-3 text-gray-300 transition-colors hover:text-white"
              >
                <Phone className="h-4 w-4 shrink-0 text-[#3B82F6]" />
                {CONTACT.phone2Display}
              </a>
              <div className="flex items-start gap-3 text-gray-400" data-testid="footer-address">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#3B82F6]" />
                {CONTACT.address}
              </div>
              <div className="flex items-center gap-3 text-gray-400" data-testid="footer-hours">
                <Clock className="h-4 w-4 shrink-0 text-[#3B82F6]" />
                {CONTACT.hours}
              </div>
              <a
                href={CONTACT.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-directions-button"
                className="inline-flex items-center gap-2 border border-white/15 px-4 py-2 font-mono2 text-xs uppercase tracking-widest text-gray-300 transition-colors hover:border-[#3B82F6] hover:text-white"
              >
                <Navigation className="h-3.5 w-3.5 text-[#3B82F6]" />
                Get Directions
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="font-mono2 text-xs tracking-widest text-gray-600">
            © {new Date().getFullYear()} BOWEGANS CAR CARE · PALANI
          </p>
          <p className="font-mono2 text-xs tracking-widest text-gray-600">
            YOUR CAR · OUR CARE
          </p>
        </div>
      </div>
    </footer>
  );
}
